/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { makeStyles } from "@material-ui/core";

const getNavWidth = (collapsed) => (collapsed ? 60 : 250);

export const useSidebarStyles = makeStyles({
	drawer: {
		flexShrink: 0,
		width: (props) => getNavWidth(props.collapsed),
		zIndex: 200,
		"& .MuiDrawer-paper": {
			boxSizing: "border-box",
			backgroundColor: "transparent",
			borderRight: 0,
			overflowY: "visible",
		},
		"& .sidebar": {
			borderRight: 0,
			width: (props) => getNavWidth(props.collapsed),
			minWidth: (props) => getNavWidth(props.collapsed),
		},
	},
	aside: {
		height: "100%",
		marginTop: 64,
		borderRightColor: "#cc1f20",
		overflow: "hidden",
		color: "#FFF",
		backgroundColor: "#cc1f20",
		"& .sidebar-inner": {
			paddingTop: 10,
			backgroundColor: "#cc1f20",
		},
	},
	menu: {
		height: "100%",
		color: "#FFF",
		backgroundColor: "#cc1f20",
	},
	mainLink: {
		color: "#FFF",
		backgroundColor: "#cc1f20",
		"& .sub-menu-content": {
			width: (props) => (props.collapsed ? 250 : "unset"),
			zIndex: 300,
		},
		"& .sub-menu-content ul": {
			overflow: "hidden",
		},
		"&.active": {
			"& > .menu-anchor": {
				backgroundColor: "#8a151687",
				color: "#FFF",
				textDecoration: "none",
			},
		},
		"& > .menu-anchor": {
			textDecoration: "none",
			paddingLeft: 10,
			"& .expand-icon": {
				display: (props) => (props.collapsed ? "none" : "flex"),
			},
			"&.active": {
				backgroundColor: "#8a1516",
				color: "#FFF",
				textDecoration: "none",
			},
			"&:hover": {
				backgroundColor: "#8a15163d",
				color: "#FFF",
				textDecoration: "none",
			},
		},
		"& .menu-suffix": {
			fontSize: 12,
			margin: 0,
		},
	},
	subLink: {
		color: "#FFF",
		backgroundColor: "#cc1f20e3",
		paddingLeft: "28px",
		"&.Mui-selected, &:hover": {
			backgroundColor: "#b82e2e !important",
			color: "#FFF",
			textDecoration: "none",
		},
	},
	navLinkLabel: {
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		overflow: "hidden",
	},
	logo: {
		height: 55,
		backgroundColor: "#FFF",
		"& img": {
			margin: "6px auto",
			padding: "0 20px",
			height: 43,
		},
	},
	collapseBtn: {
		backgroundColor: "#b61b1c",
		display: "flex",
		alignItems: "center",
		position: "relative",
		padding: "0 20px 0 10px",
		width: "100%",
		height: 40,
		color: "#FFf",
	},
});
